// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Og66","importantInfo":"styles_importantInfo__1R6er"};